angular.module('env.services.barcodeScannerListener', [])

    .service('barcodeScannerListenerService', function ($log, $q, $interval, EventingMixin) {
        var _this = this;
        var _scannedSymbolsDelay = 10;
        var _lastKeys = ''; //this variable holds the symbols scanned

        _.extend(_this, new EventingMixin(['valueScanned']));

        $(window).keypress(handleKeyPress);

        //Adds symbols one by one to the variable that holds the scanned value
        //Checks the time interval between values to 'reset' the value whenever the longer interval occurs,
        //as this is indicate usually that the value is entered by a human, not barcode scanner
        var lastSymbolEnteredAt = Date.now();

        function addChar(char) {
            //if we have a first char/symbol or a relatively small interval between symbols indicating us
            //that it is a symbol entered by a scanner
            if (_lastKeys === '' || (Date.now() - lastSymbolEnteredAt) < _scannedSymbolsDelay) {
                lastSymbolEnteredAt = Date.now();
                if (char.match(/[A-Za-z0-9_\-]/i)) {
                    _lastKeys += char;
                    while (_lastKeys.length > 50) {
                        _lastKeys.shift();
                    }
                }
            } else {
                //reset the symbols sequence as we have a longer pause indicating it is not a barcode scanned value
                _lastKeys = '';
                //And add the current one as the first symbol of the new sequence
                addChar(char);
            }
        }

        function handleKeyPress(e) {
            //First, see if we have a keypress NOT in input or textarea as we don't want to capture anything that
            //was meant to be entered there for search or 'submit to server' purposes
            if (isTextBox(e.target)) {
                _lastKeys = '';
                return;
            }

            var code = (e.keyCode ? e.keyCode : e.which);

            if (code == 13 || code == 9) { // Enter key hit/scanned
                if ((Date.now() - lastSymbolEnteredAt) < _scannedSymbolsDelay) {
                    raiseValueScannedEvent();
                } else {
                    resetLastKeys();
                }
            } else {
                addChar(String.fromCharCode(code));
            }
        }

        function raiseValueScannedEvent() {
            var scannedValue = _lastKeys;
            _lastKeys = '';
            try {
                $log.info('Entered value from barcode scanner: ' + scannedValue);
                _this.events.raise('valueScanned', {value: scannedValue});
            } catch (e) {
                $log.error('Error in barcode scanner service listener handler.', e);
            }
        }

        function isTextBox(element) {
            var tagName = element.tagName.toLowerCase();
            if (tagName === 'textarea') return true;
            if (tagName !== 'input') return false;
            var type = element.getAttribute('type') ? element.getAttribute('type').toLowerCase() : 'unknown';
            // if any of these input types is not supported by a browser, it will behave as input type text.
            var inputTypes = [
                'text', 'password', 'number', 'email', 'tel', 'url', 'search', 'date', 'datetime', 'datetime-local',
                'time', 'month', 'week'
            ];
            return inputTypes.indexOf(type) >= 0;
        }

        function resetLastKeys() {
            $log.debug('Resetting symbols from scanner.');
            _lastKeys = '';
            lastSymbolEnteredAt = Date.now();
        }

        return _this;
    })

;
